import { useGetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab } from '@/shared/api/generated';

import type { CourseAccess } from '../types/enrollment';

/**
 * Hook para carregar os dados de acesso ao curso de uma matrícula.
 * Retorna configuração de acesso e data de início vindos do endpoint `course-access-tab`.
 *
 * @param enrollmentId - ID da matrícula
 * @returns Dados de acesso ao curso, data de início e estado de loading/erro
 */
export function useEnrollmentCourseAccess(enrollmentId: number) {
  const { data, isLoading, isError } =
    useGetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab(enrollmentId);

  const courseAccess: CourseAccess = data ?? {};

  const startDate: string = data?.releasedStartDate ?? '';

  return { courseAccess, startDate, isLoading, isError } as const;
}
